import type { SandpackBundlerFiles } from "@codesandbox/sandpack-client";
import type { SANDBOX_TEMPLATES } from "@codesandbox/sandpack-react";

export type FilteredTemplates = keyof Pick<
  typeof SANDBOX_TEMPLATES,
  | "react"
  | "nextjs"
  | "react-ts"
  | "static"
  | "vanilla"
  | "vanilla-ts"
  | "test-ts"
  | "vite-react"
  | "vite-react-ts"
  | "vite"
>;

export enum CodeStack {
  JAVASCRIPT = "javascript",
}
export enum JavaScriptSandboxLayout {
  LAYOUT_1 = "layout-1",
}

export type SandboxFile = { code: string; active?: boolean };
export type SandboxFiles = Record<string, SandboxFile>;

export type JavaScriptSandboxData = {
  files: SandpackBundlerFiles;
  template: FilteredTemplates;
  shouldShowConsole?: boolean;
  shouldShowPreview?: boolean;
  shouldShowTests?: boolean;
  shouldAutoRun?: boolean;
  layout?: JavaScriptSandboxLayout;
};

export interface LiveCodeBlockAttributes {
  codeStack?: CodeStack;
  data?: JavaScriptSandboxData | null;
  caption?: string | null;
}
